import httpService from '@/modules/common/services/httpService';

const getExternalApplications = async () => httpService.get('v2/settings/get_external_menu_items_applications')
  .then((res) => res.data?.data.apps || []);
export default {
  getExternalApplications,
};
